<template>
  <div>
    <Notification ref="notif" v-bind="notif" v-on:update="notif.show = $event"></Notification>
    <div id="loginContainer" class="login-form">
      <v-container fluid>
        <v-layout justify-center align-center>
          <v-flex >
            <img :src="logo" alt="logo" />
          </v-flex>
        </v-layout>
      </v-container>

      <h2 class="login-heading"><v-icon medium color="teal darken-2">lock</v-icon>  L O G I N </h2>
      &nbsp;&nbsp;
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="username" label="Username" required></v-text-field>
        <v-text-field
          v-model="password"
          :rules="[rules.required]"
          type="password"
          name="input-10-1"
          label="Password"
          @keyup.enter="login"
          ></v-text-field>
 <v-select
          :items="gatewayArray"
          label="Gateway(s)"
          outlined
          v-model="gateway"
          :rules="[rules.required]"
        ></v-select>

        <v-layout row wrap align-center>
          <v-flex xs12 sm12>
            <v-btn block class="green darken-1" dark @click="login">LOGIN</v-btn>
          </v-flex>
          <br>
          <v-progress-linear :indeterminate="true" height="5" color="green" v-if="isConnected"></v-progress-linear>
        </v-layout>
      </v-form>
    </div>
  </div>
</template>

<script>
import foot2 from "@/assets/agentHelperLogo.svg";
import Notification from "@/components/Notification.vue";
import DataService from "@/services/data-service";

const dataService = new DataService();

export default {
  name: "login",
  loading: true,
  components: {
    Notification
  },
  data: () => ({
    gatewayArray: ["Production", "CTD"],
    gateway: "Production",
    logo: foot2,
    notif: {
      color: "success",
      message: "",
      show: false
    },
    username: "",
    password: "",
    isAuthenticated: false,
    valid: true,
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      emailMatch: v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    },
    isConnected: false
  }),
  mounted() {
    const that = this;
    if (that.$route.query && that.$route.query.message) {
      that.showNotif({ color: "error", message: that.$route.query.message });
    }
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    login() {
      this.isDatasetConnectFailed = false;
      if (this.username !== "" && this.password !== "" && this.gateway !== "") {
       this.$store.commit("setGatewayInfo",this.gateway);
        this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password
          })
          .then(IsAuthenticated => {
            if (!IsAuthenticated) {
              this.showNotif({
                color: "error",
                message: "Invalid Username or Password"
              });
            } else if (IsAuthenticated) {
              const routeInfo = this.$store.getters.getDefaultRoute;
              if (routeInfo && routeInfo.route) {
                this.$router.replace(`/${routeInfo.route}`);
              } else if (routeInfo && routeInfo.name) {
                this.$router.replace(
                  `/error/You only have ${
                    routeInfo.name
                  } page access which you can't use directly/code/401`
                );
              } else {
                this.$router.replace(
                  "/error/You don't have any page access/code/401"
                );
              }
            }
          })
          .catch(error => {
            console.log(error);
            if (
              error &&
              error.response &&
              error.response.data &&
              error.response.data.error_description
            ) {
              this.showNotif({
                color: "error",
                message: error.response.data.error_description
              });
            } else {
              this.showNotif({ color: "error", message: "not responding." });
            }
          });
      }
    }
  }
};
</script>
<style>
body {
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
}
html,
body {
}

.login-form {
  /* background: #fff;
  width: 30%;
  margin: auto auto auto auto; */
  border: 1px solid #ccc;
  padding: 2%;
  width: 30%;
  height: auto;
  background: #fff;

  position: absolute; /*it can be fixed too*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin-top: 70px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;

  /*this to solve "the content will not be cut when the window is smaller than the content": */
  max-width: 100%;
  max-height: 100%;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .login-form {
    /* background: #fff;
  width: 30%;
  margin: auto auto auto auto; */
    border: 1px solid #ccc;
    padding: 2%;
    width: auto;
    height: auto;
    background: #fff;

    position: absolute; /*it can be fixed too*/
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width: 100%;
    max-height: 100%;
  }
}

#loginContainer img {
  width: 50%;
  display: block;
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: auto;
  margin-right: auto;
}

.login-heading {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 25px;
  text-align: center;
  color: darkgreen;
  margin-top: -30px;
}
.form-container {
}

#app {
  background: #fff;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
